export enum MixpanelEvent {
  ScreenView = 'screen_view',
  UserAction = 'user_action',
  APIAction = 'api_action',
}
